import type {
  SalesHeadlineOfferType,
  SalesHeadlineTone,
  SalesHeadlineTrafficSource,
} from "@/features/tools/proToolTypes";

export const salesOfferTypeOptions: Array<{
  value: SalesHeadlineOfferType;
  label: string;
}> = [
  { value: "lead_magnet", label: "Lead magnet" },
  { value: "low_ticket_product", label: "Low-ticket product" },
  { value: "subscription", label: "Subscription" },
  { value: "service_front_end", label: "Service front-end" },
  { value: "paid_workshop", label: "Paid workshop" },
  { value: "bonus_asset", label: "Bonus asset" },
  { value: "not_sure", label: "Not sure yet" },
];

export const salesToneOptions: Array<{
  value: SalesHeadlineTone;
  label: string;
}> = [
  { value: "direct", label: "Direct" },
  { value: "premium", label: "Premium" },
  { value: "friendly", label: "Friendly" },
  { value: "educational", label: "Educational" },
  { value: "urgent", label: "Urgent" },
  { value: "curiosity_driven", label: "Curiosity-driven" },
];

export const salesTrafficSourceOptions: Array<{
  value: SalesHeadlineTrafficSource;
  label: string;
}> = [
  { value: "organic_social", label: "Organic social" },
  { value: "email_list", label: "Email list" },
  { value: "paid_ads", label: "Paid ads" },
  { value: "affiliate_jv", label: "Affiliate or JV" },
  { value: "webinar", label: "Webinar" },
  { value: "community", label: "Community" },
  { value: "unknown", label: "Not sure yet" },
];
